import { useEffect, useState } from 'react';
import { Grid, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import classNames from 'classnames/bind';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { PatientsHeader } from './PatientsHeader';
import style from './Patients.module.scss';
import { Patient } from '../../types';
import { Button, Loader } from '../../components/atoms';
import { Input } from '../../components/molecules';
import { fetchPatients, patientsSliceSelector } from './patientListSlice';

const cx = classNames.bind(style);

type MySQLPatient = { name: string; email: string; ninoxId: number };

export function Patients(): JSX.Element {
  const dispatch = useDispatch();
  const { patients } = useSelector(patientsSliceSelector);
  const [patientsList, setPatientsList] = useState<MySQLPatient[]>([]);
  const intl = useIntl();
  const navigate = useNavigate();

  const showPatientinfoComponent = (patientId: any, page: string) => {
    navigate(`/patients/${page}/${patientId}`);
  };

  useEffect(() => {
    dispatch(fetchPatients());
  }, []);

  const search = (input: string) => {
    const trimmed = input.trim();
    if (!trimmed) {
      setPatientsList([]);
    } else {
      setPatientsList(
        patients.filter(
          ({ name, email, ninoxId }: MySQLPatient) =>
            name.toLowerCase().includes(input) || email.toLowerCase() === input || String(ninoxId) === input
        )
      );
    }
  };

  const pageClasses = cx('container');
  const MainDiv = cx({ PatientsMainDiv: true });
  const TableContainerClasses = cx({ PatientsTableContainer: true });
  const InputClasses = cx({ PatientsInput: true });

  const renderPatientList = () =>
    patientsList.map(({ name, ninoxId }: MySQLPatient, index: number) => (
      <>
        <TableRow
          hover
          key={index}
          className={style.PatientsPointer}
          onClick={() => showPatientinfoComponent(ninoxId, 'Overview')}
        >
          <TableCell className={style.PatientsTableCell}>
            <div className={style.PatientsFlexContainer}>
              <div className={style.PatientsId}>ID: {ninoxId}</div>
              <div className={style.PatientsName}>{name}</div>
            </div>
          </TableCell>
        </TableRow>
      </>
    ));

  return (
    <div className='details_container'>
      <div className={pageClasses}>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} className={MainDiv}>
            <PatientsHeader />
            <Grid container>
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <Input
                  type='search'
                  placeholder={intl.formatMessage({ id: 'patients.SearchPatients' })}
                  inputMode='search'
                  onChange={(e) => search(e.target.value.toLowerCase())}
                  icon='magnify'
                  className={InputClasses}
                />
              </Grid>
            </Grid>
            {!patients.length ? (
              <p>Laden...</p>
            ) : (
              <TableContainer className={TableContainerClasses}>
                <Table size='medium'>
                  <TableBody>{renderPatientList()}</TableBody>
                </Table>
              </TableContainer>
            )}
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
